<template>
  <div class="resourceLedgerList">
    <div class="filters">
      <el-form :inline="true">
        <!-- 项目名称input -->
        <el-form-item>
          <el-input class="searchInput" v-model="itemName" :placeholder="$t('lang.lbl_resourceLedgerList_ItemName')">
          </el-input>
        </el-form-item>
        <!-- 选择一级分类 -->
        <el-form-item>
          <el-select v-model="firstsort" @change="getSeleList('twoResourceType' + firstsort)">
            <el-option v-for="item in firstsortlist" :key="item.id" :label="item.code" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择二级分类 -->
        <el-form-item>
          <el-select v-model="secondsort">
            <el-option key :label="$t('lang.lab_pleSelsecondsort')" value="0" v-if="this.firstsort === '0'"></el-option>
            <el-option v-for="item in secondsortlist" :key="item.id" :label="item.code" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择点位属性 -->
        <el-form-item>
          <el-select class="select" v-model="pointAttr">
            <el-option v-for="item in pointAttrList" :key="item.id" :label="item.code" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- 选择状态 -->
        <el-form-item>
          <el-select class="select" v-model="state">
            <el-option v-for="item in stateList" :key="item.id" :label="item.code" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <!-- 提交 -->
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="add">{{$t('lang.btn_addLedger')}}</el-button>
      <el-table :data="tableData" class="wid100" :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109" :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange">
        <!-- resourceLedgerListCheckbox -->
        <el-table-column type="selection" width="55" v-if="this.resourceLedgerListCheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <!-- 项目名称 -->
        <el-table-column prop="ItemName" :label="$t('lang.lbl_resourceLedgerList_ItemName')"></el-table-column>
        <!-- 一级分类 -->
        <el-table-column prop="OneResourceType" sortable :label="$t('lang.lbl_resourceLedgerList_OneResourceType')">
          <template slot-scope="scope">
            <span v-for="item in firstsortlist" :key="item.id">
              <span v-if="scope.row.OneResourceType === item.value">{{item.code}}</span>
            </span>
          </template>
        </el-table-column>
        <!-- 二级分类 -->
        <el-table-column prop="Code" :label="$t('lang.lbl_resourceLedgerList_TwoResourceType')">
        </el-table-column>
        <!-- 点位属性 -->
        <el-table-column prop="PointPositionAttr" sortable :label="$t('lang.lbl_resourceLedgerList_PointPositionAttr')">
          <template slot-scope="scope">
            <span v-for="item in pointAttrList" :key="item.id">
              <span v-if="scope.row.PointPositionAttr === item.value">{{item.code}}</span>
            </span>
          </template>
        </el-table-column>
        <!-- 分类 -->
        <el-table-column prop="State" sortable :label="$t('lang.lbl_resourceLedgerList_State')">
          <template slot-scope="scope">
            <span v-for="item in stateList" :key="item.id">
              <span v-if="scope.row.State.toString()=== item.value">{{item.code}}</span>
            </span>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class="orange" @click="deletetable(scope.row.Id)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:resourceLedgerList
   *@Description:资源台账
   *@author:李斌
   *@Copyright:格众科技
   *@date:2020-03-27
   */
  export default {
    name:'/manage/main.resourceLedgerList',
    data() {
      return {
        list: [],
        pageCount: 0, // 总页数
        pageNo: 1, // 第几页
        pageSize: 10, // 每页显示数
        tableData: [], // 列表数组  
        resourceLedgerListCheckbox: require('@/config/enum').resourceLedgerListCheckbox, // 是否隐藏复选框
        itemName: '', // 项目名称
        firstsort: '0', // 一级分类
        firstsortlist: [], // 一级分类列表
        secondsort: '0', // 二级分类列表
        secondsortlist: [], // 二级分类列表
        pointAttr: '0', // 点位属性
        pointAttrList: [], // 点位属性列表
        state: '0', // 选择状态
        stateList: [], // 状态列表
        multipleSelection: [], // 多选框
      }
    },
    created() {
      setTimeout(() => {
        window.localStorage.setItem('resourceLedgerAddform', '')
        window.localStorage.setItem('resourceLedgerAddsaveData', '')
      }, 200)
      // 获取下拉的列表
      this.getSeleList('oneResourceType')
      this.getSeleList('resourceState')
      this.getSeleList('pointPositionAttr')
      // 获取列表
      this.getTablelist()
    },
    activated(){
      // 获取下拉的列表
      this.getSeleList('oneResourceType')
      this.getSeleList('resourceState')
      this.getSeleList('pointPositionAttr')
      // 获取列表
      this.getTablelist()
    },
    methods: {
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      getSeleList(code) {
        this.$get(`/getValueListByCode?code=${code}`).then(res => {
            if (res && res.errCode === 0) {
              if (code === 'oneResourceType') {
                this.firstsortlist = res.result
              } else if (code === 'resourceState') {
                this.stateList = res.result
              } else if (code === 'pointPositionAttr') {
                this.pointAttrList = res.result
              } else {
                this.secondsortlist = res.result
                this.secondsort = '0'
                if (code === 'twoResourceType0') {
                  this.secondsortlist = []
                  this.secondsort = '0'
                }
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 资源台账
      getTablelist() {
        let loading = this.$loading()
        this.$get(
          `/getResourceLedgerList?ItemName=${this.itemName}&OneResourceType=${this.firstsort}&TwoResourceType=${this.secondsort}&PointPositionAttr=${this.pointAttr}&State=${this.state}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
          ).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.pageCount = res.pageCount
              this.tableData = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getTablelist()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getTablelist()
      },
      edit(row) {
        window.localStorage.setItem('resourceLedgerAddform', '')
        window.localStorage.setItem('resourceLedgerAddsaveData', '')
         this.$router.push({
          name: 'resourceLedgerAdd',
          query: row
        })
      },
      add() {
        window.localStorage.setItem('resourceLedgerAddform', '')
        window.localStorage.setItem('resourceLedgerAddsaveData', '')
        this.$router.push({
          name: 'resourceLedgerAdd'
        })
      },
      commit() {
        this.pageNo = 1
        this.getTablelist()
      },
      deletetable(id) {
        let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdeleteResourceLedger'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          ).then(() => {
            this.$delete(`delResourceLedgerById/` + id).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      }
    }
  }
</script>

<style lang="scss">
</style>